import {
    AddCostSplitRequestDto,
    CostAllocationPayerType,
    CostAllocationRefersTo,
} from 'types/settlementChildren/settlementChildren';
import { CostAllocationFormFields, PriceDeductionType } from 'types';
import pick from 'lodash/pick';
import { parseFormattedBankAccountNumberIntoBankAccountNumber } from 'utils/parsers/bankAccountNumber/parseFormattedBankAccountNumberIntoBankAccountNumber';

export const parseCostAllocationFormFieldsToAddCostAllocationDTO = (
    costAllocation: CostAllocationFormFields,
): AddCostSplitRequestDto => ({
    correctionId: costAllocation.correctionId ? costAllocation.correctionId : null,
    monthlySettlementId: costAllocation.monthlySettlementId,
    additionalCostId: costAllocation.additionalCostId,
    nip: costAllocation.nip,
    foundationName: costAllocation.foundationName,
    address: {
        ...pick(costAllocation, ['city', 'street', 'zipCode']),
    },
    bankAccountNumber: costAllocation.bankAccountNumber
        ? parseFormattedBankAccountNumberIntoBankAccountNumber(costAllocation.bankAccountNumber)
        : null,
    invoiceNotes: costAllocation.invoiceNotes,
    costCategory: costAllocation.costCategory
        ? costAllocation.costCategory
        : CostAllocationRefersTo.OTHER,
    courseIds: costAllocation.refersToCourses ? costAllocation.refersToCourses : [],
    splitType: costAllocation.type as PriceDeductionType,
    payerType: costAllocation.payerType as CostAllocationPayerType,
    sourceType: costAllocation.sourceType,
    percentageAmount: costAllocation.percentageAmount ? costAllocation.percentageAmount : null,
    entryGrossAmount: costAllocation.specificAmount ? costAllocation.specificAmount : null,
    courseIdProvided: costAllocation.refersToCourses && costAllocation.refersToCourses.length > 0,
    amountFilled: Boolean(costAllocation.specificAmount || costAllocation.percentageAmount),
});
